<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/priority-mapping" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditSubCategory") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.MainCategory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.MainCategory')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="mainCategory"
                    :options="subCategoryTemplate.problemsDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(mCodeValue) => mCodeValue.id"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.SubCategory')"
              >
                <vs-input
                  type="text"
                  :label="$t('setup.label.SubCategory')"
                  v-model="subCategory"
                  class="w-full font-semibold mb-1 starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Priority")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  label="chargeCode"
                  v-model="priority"
                  :options="pririty"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">
                    {{ option.chargeCode }}
                  </template>
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.SlaInHours')"
              >
                <vs-input
                  type="text"
                  :label="$t('setup.label.SlaInHours')"
                  v-model="slaInHours"
                  class="w-full font-semibold mb-1 starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editSubCategory"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      mainCategory: "",
      subCategory: "",
      priority: "",
      slaInHours: 0,
      pririty: ["HIGH", "MEDIUM", "LOW"],
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      subCategoryTemplate: (state) => state.priorityMapping.subCategoryTemplate,
      editCategoryTemplate: (state) =>
        state.priorityMapping.editCategoryTemplate,
    }),
  },
  methods: {
    async getPriorityMappingList() {
      try {
        await this.$store.dispatch(
          "priorityMapping/fetchEditCategoryTemplate",
          this.$route.params.id
        );
        let categoryobj = this.subCategoryTemplate.problemsDatas.find(
          (el) => el.mCodeValue === this.editCategoryTemplate.mainCategory
        );
        this.mainCategory = categoryobj.id;
        this.subCategory = this.editCategoryTemplate.subCategory;
        this.priority = this.editCategoryTemplate.priority;
        this.slaInHours = this.editCategoryTemplate.timetaken;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getSubCategoryTemplate() {
      try {
        await this.$store.dispatch("priorityMapping/fetchsubCategoryTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getcategoryTemplate() {
      try {
        await this.$store.dispatch(
          "priorityMapping/fetchCategoryTemplate",
          this.mainCategory
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async editSubCategory() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        mainCategory: this.mainCategory,
        subCategory: this.subCategory,
        priority: this.priority,
        timeTaken: this.slaInHours,
        locale: "en",
      };
      await this.$store.dispatch("priorityMapping/updateSubCategory", {
        id: this.$route.params.id,
        payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Sub Category Edited Successfully!",
        type: "success",
      });
      this.$router.push(`/setup/priority-mapping`);
    },
    cancel() {
      this.$router.push(`/setup/priority-mapping`);
    },
  },

  async mounted() {
    await this.getSubCategoryTemplate();
    await this.getPriorityMappingList();
  },
};
</script>
